import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusyIndicatorService {
  busy: Subject<boolean>;

  constructor(private logger: NGXLogger) {
    this.busy = new Subject();
  }

  update(value: boolean) {
    this.logger.log('busy', value);
    this.busy.next(value);
  }
}
